import React from 'react';

const HelloWorld = () => {
  return (
    <div>
      <h3>Hello, Test!</h3>
      <hr />
    </div>
  );
};

export default HelloWorld;
